var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 37.5,
    viewBox: "0 0 25.5 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22",
    "data-name": "Groupe 22",
    transform: "translate(-5.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M6,3m0,8a8,8,0,0,1,8-8h8a8,8,0,0,1,8,8V31a8,8,0,0,1-8,8H14a8,8,0,0,1-8-8Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M12,3V17",
    transform: "translate(6)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_96",
    "data-name": "Trac\\xE9 96",
    d: "M6,10H30",
    transform: "translate(0 7)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.5855f6bcb823381d7de04525318c7235.svg";
export { ForwardRef as ReactComponent };